import { CreateInvoiceLineItem } from '../../types/admin';
import { VatRate } from '../../invoicing/tax';
import * as impactConstants from './impact-constants';

export const defaultAvoidanceImpact: CreateInvoiceLineItem[] = [
  {
    quantity: 1,
    unitPrice: impactConstants.CAPTURE_PRICE,
    projectId: impactConstants.CAPTURE_AVOIDANCE_ID,
    vatRate: VatRate.ZERO,
  },
  {
    quantity: 1,
    unitPrice: impactConstants.CAPTURE_PRICE,
    projectId: impactConstants.GENERAL_AVOIDANCE_ID,
    vatRate: VatRate.ZERO,
  },
  {
    quantity: 1,
    unitPrice: impactConstants.WETLANDS_PRICE,
    projectId: impactConstants.WETLANDS_AVOIDANCE_ID,
    vatRate: VatRate.ZERO,
  },
  {
    quantity: 1,
    unitPrice: impactConstants.FORESTRY_PRICE,
    projectId: impactConstants.FORESTRY_AVOIDANCE_ID,
    vatRate: VatRate.ZERO,
  },
  {
    quantity: 1,
    unitPrice: impactConstants.COMMUNITY_PRICE,
    projectId: impactConstants.COMMUNITY_AVOIDANCE_ID,
    vatRate: VatRate.ZERO,
  },
];
